import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { BaseButton } from '../../../../../../BaseComponents';
import { useRemoveLastSelectedFlight } from '../../model/useRemoveLastSelectedFlight';
const RemoveLastSelectedFlightButton = ({ label }) => {
    const { t } = useTranslation('Exchange');
    const { onRemoveLastSelectedFlight } = useRemoveLastSelectedFlight();
    return (React.createElement(BaseButton, { variant: "text", onClick: onRemoveLastSelectedFlight }, label || t('RemoveLastSelectedFlightButton.Label')));
};
export default RemoveLastSelectedFlightButton;
